import { useInactivityLogout } from '../Services/useInactivityLogout';

const InactivityGuard = () => {
  useInactivityLogout();
  return null; // no renderiza nada, solo activa el timer
};

export default InactivityGuard;